import { api, apiAxiosInstance } from './api';

export const createVehiclesGroups = (payload) => {
  return api.post('/vehicle_group', payload);
};

export const updateVehiclesGroup = (id, payload) => {
  return api.put(`/vehicle_group/${id}`, payload);
};

export const getAvailableLocations = (params) => {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
  return api.get(`/location?${queryString}`);
};

export const getVehiclesGroupsLocations = (id, params) => {
  return api.get(`/vehicle_group/${id}/location`, params);
};

export const addLocationToVehiclesGroups = (id, payload) => {
  return api.post(`/vehicle_group/${id}/location`, payload);
};

export const addServiceToVehiclesGroups = (id, payload) => {
  return api.post(`/vehicle_group/${id}/share`, payload);
};

export const unshareFleet = (id, payload) => {
  return api.post(`/vehicle_group/${id}/unshare`, payload);
};

export const getVehicleGroupById = (id) => {
  return api.get(`/vehicle_group/${id}`);
};

export const removeLocationFromVehiclesGroups = (id, locationId) => {
  return api.delete(`/vehicle_group/${id}/location/${locationId}`);
};

export const fetchVehiclesGroups = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get(`/vehicle_group`, payload, options);
};

export const fetchVehiclesGroupById = (id) => {
  return api.get(`/vehicle_group/${id}`);
};

export const fetchVehiclesGroupRulesets = (id) => {
  const params = new URLSearchParams();
  params.append('rule_set_type', 'PRICING');
  return api.get(`/vehicle_group/${id}/rule_set_times`, params);
};

export const fetchRelatedRuleset = (reference, params = {}) => {
  const _params = new URLSearchParams();
  _params.append('group_type', 'VEHICLE');
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => _params.append(key, item));
    else return _params.append(key, value);
  });
  return api.get(`/${reference}/rule_set`, _params);
};

export const addRulesetToVehiclesGroups = (groupId, payload) => {
  return api.post(`/vehicle_group/${groupId}/rule_set_times`, payload);
};

export const updateRulesetToVehiclesGroups = (groupId, ruleset, payload) => {
  return api.put(`/vehicle_group/${groupId}/rule_set_times/${ruleset}`, payload);
};

export const editRulesetToVehiclesGroups = (groupId, ruleset, payload) => {
  return api.put(`/vehicle_group/${groupId}/rule_set_times/${ruleset}`, payload);
};

export const deleteRulesetFromVehiclesGroups = (groupId, ruleset, payload) => {
  return apiAxiosInstance.delete(`/vehicle_group/${groupId}/rule_set_times/${ruleset}`, payload);
};

export const fetchUsageAggregates = (params) => {
  return api.get(`/vehicle_group/aggregates`, params);
};

export const fetchVehicleGroupsTimezones = (params) => {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
  return api.get(`/vehicle_group/timezone?${queryString}`);
};

export const fetchVehicleGroupsRRStimes = (id) => {
  return api.get(`/vehicle_group/${id}/reservation_rules_set_times`);
};

export const addReservationRulesetToVehiclesGroups = (groupId, payload) => {
  return api.post(`/vehicle_group/${groupId}/reservation_rules_set_times`, payload);
};

export const updateReservationRulesetToVehiclesGroups = (groupId, ruleset, payload) => {
  return api.put(`/vehicle_group/${groupId}/reservation_rules_set_times/${ruleset}`, payload);
};

export const deleteReservationRulesetFromVehiclesGroups = (groupId, ruleset) => {
  return api.delete(`/vehicle_group/${groupId}/reservation_rules_set_times/${ruleset}`);
};

export const fetchVehicleGroupsBHTimes = (id) => {
  return api.get(`/vehicle_group/${id}/business_hours_rules_set_times`);
};

export const addBHRulesetToVehiclesGroups = (groupId, payload) => {
  return api.post(`/vehicle_group/${groupId}/business_hours_rules_set_times`, payload);
};

export const updateBHRulesetToVehiclesGroups = (groupId, ruleset, payload) => {
  return api.put(`/vehicle_group/${groupId}/business_hours_rules_set_times/${ruleset}`, payload);
};

export const deleteBHRulesetFromVehiclesGroups = (groupId, ruleset) => {
  return api.delete(`/vehicle_group/${groupId}/business_hours_rules_set_times/${ruleset}`);
};

export const deleteVehicleGroup = (groupId) => api.delete(`/vehicle_group/${groupId}`);
